// Global packages and components
import {
  ProductImage,
  Price,
  QuantitySelector,
  ProductTags,
} from '~/components'

// Types
import type { PriceValue } from '~/types'

interface Props {
  name: string
  image: {
    imageUrl: string
  }
  price: PriceValue
  quantity: number
  maxQuantity: number
  minQuantity: number
  isMandatory?: boolean
  productType: string
  setQuantity: (e: string) => void
}

// Main export
const ProductExtrasCard = ({
  name,
  image,
  price,
  quantity,
  maxQuantity,
  minQuantity,
  isMandatory,
  productType,
  setQuantity,
}: Props) => (
  <div className="flex h-full flex-row rounded-2xl bg-neutral-150 p-3 md:flex-col">
    <div className="mr-4 size-28 shrink-0 md:mb-3 md:mr-0 md:aspect-square md:size-auto">
      <ProductImage
        src={image?.imageUrl ? image.imageUrl : 'https://placehold.co/600x400'}
        tags={isMandatory ? [{ label: 'Required' }] : []}
        tagsType="pill"
        alt={name}
        adaptive
      />
    </div>
    <div className="mt-auto flex h-full flex-col">
      <h3 className="mb-2 text-base font-semibold md:mb-7">{name}</h3>
      <div className="mt-auto flex flex-col gap-2 md:flex-row md:justify-between">
        <div className="flex flex-col">
          <p className="mb-1 text-sm">
            {productType == 'bulk'
              ? 'Hire for'
              : productType == 'consumable'
                ? 'Buy for'
                : null}
          </p>
          <Price
            price={{ currency: price?.currency, amount: price?.amount }}
            size="sm"
            highlight
          />
        </div>
        <div className="flex flex-wrap items-center gap-2 pt-2 md:pt-0">
          <QuantitySelector
            min={minQuantity}
            max={maxQuantity}
            value={String(quantity)}
            setValue={setQuantity}
            disabled={isMandatory}
            errorAbove
            compact
          />
          {isMandatory && (
            <div className="md:hidden">
              <ProductTags
                tags={[{ label: 'Required' }]}
                tagsType="pill"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)

export default ProductExtrasCard
